import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import { Apitoken, Authtoken } from "../Global";
const SupplierView = () => {
  let { id } = useParams();
  const [menu, setMenu] = useState(false);
  const [value, setValue] = useState({});
  const [permission, setPermission] = useState({});
  useEffect(() => {
    const modulePermission = FindModuleById(131);
    setPermission(modulePermission);

    axios
      .get(`/suppliers/edit/${id}`, {
        headers: {
          Authorization: `Bearer ${Authtoken}`,
          Apitoken: Apitoken,
        },
      })
      .then((response) => {
        if (response.data.code === 200) {
          setValue(response.data.data.supplier);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, [id]);


  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  console.log(value);

     const currencylist =  [
    {
        "value": 1,
        "symbol": "€",
    },
    {
        "value": 2,
        "symbol": "$",
    },
    {
        "value": 3,
        "symbol": "£",
    },
    {
        "value": 4,
        "symbol": "dh",
    }
];
  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">View Supplier</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/suppliers">
                        Supplier
                      </Link>
                    </li>
                    <li className="breadcrumb-item active">
                      View Supplier
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                {permission?.list == 1 && (
                  <div className="card">
                    <div className="card-body">
                      <h4 className="card-title">Supplier Details</h4>
                      <table className="table table-bordered">
                        <tr>
                          <th className="p-3">Name</th>
                          <td className="p-3">
                            {value.name}
                          </td>
                        </tr>
                        <tr>
                          <th className="p-3">Supplier Type</th>
                          <td className="p-3">
                           {(value.supply_type)?value.supply_type.title:""}
                          </td>
                        </tr>
                        <tr>
                          <th className="p-3">Contact Person</th>
                          <td className="p-3">
                            {value.contact_person}
                          </td>
                        </tr>
                        <tr>
                          <th className="p-3">Phone Number</th>
                          <td className="p-3">
                            {value.phone_number}
                          </td>
                        </tr>
                        <tr>
                          <th className="p-3">Bank Number</th>
                          <td className="p-3">
                            {value.bank_number}
                          </td>
                        </tr>
                        <tr>
                          <th className="p-3">Bank Name</th>
                          <td className="p-3">
                            {value.bank_name}
                          </td>
                        </tr>
                        <tr>
                          <th className="p-3">IF</th>
                          <td className="p-3">
                            {value.if}
                          </td>
                        </tr>
                        <tr>
                          <th className="p-3">ICE</th>
                          <td className="p-3">
                            {value.ice}
                          </td>
                        </tr>
                        <tr>
                          <th className="p-3">Address</th>
                          <td className="p-3">
                            {value.address}
                          </td>
                        </tr>





                      </table>
                      {value.supplier_type == 6 && (
                        <table className="table table-bordered">
                          <tr>
                            <th colSpan={2} className="p-3"><h5>Supplier Prices</h5></th>
                          
                          </tr>
                           <tr>
                            <th className="p-3">Designation</th>
                            <th className="p-3">Price</th>
                            
                          </tr>
                          {value.supplier_prices &&
                            value.supplier_prices.map((item, index) => (
                              <tr   key={item.price || index}>
                                <td className="p-3">{item.designation}</td>
                             
                                <td className="p-3">{item.price}{currencylist.find(c => c.value === item.currency)?.symbol}</td>
                              </tr>
                            ))}
                        </table> 
                      )}


                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default SupplierView;
